module.exports = __webpack_public_path__ + "static/media/bar.0ef5fe6b.jpg";